import React, { ReactNode } from 'react';
import './InfoCard.css';
import { ImageContainer } from './ImageContainer';



interface InfoCardProps {
  headerText: string,
  style?: React.CSSProperties,
  details?: string[] | [],
  imageUrl?: string | null,
  hideImage?: boolean,
  horizontal?: boolean,
  cardStyle?: boolean,
  small?: boolean,
  selected?: boolean,
  endElements?: ReactNode | null,
  onClick?: () => void,
}

const InfoCard = ({
  headerText,
  style = {},
  details = [],
  imageUrl = null,
  hideImage = false,
  endElements = null,
  horizontal = false,
  small = false,
  cardStyle = true,
  selected = false,
  onClick = () => { },
}: InfoCardProps) => {

  return (
    <div
      className={`item-card${!cardStyle ? ' no-background' : ''}${horizontal ? ' horizontal' : ''}${selected ? ' selected' : ''}${small ? ' scaled-down' : ''}`}
      style={style}
      onClick={onClick}
    >
      {!hideImage && (<ImageContainer imageUrl={imageUrl} alt={headerText} />)}

      <div className='d-flex-row medium-text flex-nowrap w-100'>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <p className='item-header'>{headerText}</p>
          {details.length > 0 && (
            <div className='item-details'>
              {details.map((detail, index) => (
                detail != null && detail.trim() !== '' ? (
                  <p key={index}>
                    {detail}
                  </p>
                ) : null
              ))}
            </div>
          )}
        </div>

        {endElements && (
          <div className='end-elements'>
            {endElements}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoCard;